export default [{
	titulo: 'Avisos e Comunicados',
	icone: 'menu-icon fa fa-caret-right',
	url: '/servicos/licitacoes-comunicados',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]